import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import styles from "./RefillUnitInputPanel.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaFormField } from "@coworker/apprestructured/src/shared/wrappers/FixaFormField/FixaFormField";
import { Trans } from "@coworker/locales";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import NoticeRedSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/NoticeRedSmallIconPath";
import WarningTriangleOrangeSmallPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/WarningTriangleOrangeSmallPath";
import PencilIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PencilIconPath";
import { RefillUnitType } from "../../../constants/RefillUnitType";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";

export type RefillUnitInputPanelProps = {
  infoText?: string;
  type: RefillUnitType;
  value: number;
  onChange: (value: number) => void;
  suffixLabel: string;
  max: number;
  current: number;
  disabled?: boolean;
  errorMsg?: string;
  warningMsg?: string;
  isError?: boolean;
  isWarning?: boolean;
  isThresholdWarning: boolean;
  onEditSettings?: () => void;
};

export function RefillUnitInputPanel({
  infoText,
  type,
  value,
  onChange,
  suffixLabel,
  max,
  current,
  disabled,
  errorMsg,
  warningMsg,
  isError,
  isWarning,
  isThresholdWarning,
  onEditSettings,
}: RefillUnitInputPanelProps) {
  return (
    <>
      {infoText && (
        <div className={styles["infoTextRow"]}>
          <FixaText textStyle="Body.S" className={styles["infoText"]}>
            {infoText}
          </FixaText>
          {onEditSettings && (
            <FixaButton
              iconOnly
              ssrIcon={PencilIconPath}
              onClick={onEditSettings}
              type="tertiary"
              size="xsmall"
              className={styles["editSettingsButton"]}
              disabled={disabled}
            />
          )}
        </div>
      )}
      <FixaFormField
        valid={isError ? "error" : isWarning ? "warning" : "success"}
        shouldValidate={(isError || isWarning) ?? false}
        className={styles["formField"]}
      >
        <FixaInputField
          id={String(type)}
          type="number"
          value={String(value)}
          onChange={(e) => onChange(Number(e.target.value))}
          className={styles["inputField"]}
          suffixLabel={suffixLabel}
          disabled={disabled}
        />
      </FixaFormField>
      <div className={styles["capacityAndMessages"]}>
        {isError && errorMsg ? (
          <FixaText textStyle="Body.S" className={styles["error"]}>
            <FixaSSRIcon paths={NoticeRedSmallIconPath} />
            {errorMsg}
          </FixaText>
        ) : (
          isWarning &&
          warningMsg && (
            <FixaText textStyle="Body.S" className={styles["warning"]}>
              <FixaSSRIcon paths={WarningTriangleOrangeSmallPath} />
              {warningMsg}
            </FixaText>
          )
        )}
        {!disabled && (
          <>
            <FixaText textStyle="Body.S">
              {!isError && !isWarning && <Trans>maximumCapacityString</Trans>}
            </FixaText>
            <FixaText textStyle="Body.S">
              <span
                className={`${isError ? styles["error"] : isWarning ? styles["warning"] : ""}`}
              >
                {current}
              </span>
              /{max}
            </FixaText>
          </>
        )}
      </div>
      {isThresholdWarning && (
        <FixaInlineMessage
          variant="negative"
          title={<Trans>maximumQuantityMessageString</Trans>}
          className={styles["thresholdWarning"]}
        />
      )}
    </>
  );
}
